import { render, staticRenderFns } from "./EcosystemNeed.vue?vue&type=template&id=6411793e&scoped=true&"
import script from "./EcosystemNeed.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcosystemNeed.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6411793e",
  null
  
)

export default component.exports